import 'antd/dist/reset.css'
import './index.scss'

import { CacheBuster } from 'components/cache-buster/CacheBuster'
import ReactDOM from 'react-dom/client'

import App from './App'
import reportWebVitals from './reportWebVitals'

const HOSTNAME_REDIRECTS: Record<string, string> = {
  'sj.okulsepeti.com.tr': 'istanbulsj.okulsepeti.com.tr',
  'sezin.okulsepeti.com.tr': 's12.okulsepeti.com.tr',
}
const currentHost = window.location.hostname
if (HOSTNAME_REDIRECTS[currentHost]) {
  window.location.replace(window.location.href.replace(currentHost, HOSTNAME_REDIRECTS[currentHost]))
}   

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <CacheBuster>
    <App />
  </CacheBuster>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
